// Card de KPI com as 4 janelas do SDD §3.4: valor grande = MTD, linha compacta com Hoje / M-1 / Referência.
// Δ colorido pela direção favorável (padrão Árvore de Perdas): up = maior melhor, down = menor melhor.
import Dica from './Dica';

type Direcao = 'up' | 'down';
type Fmt = (n: number | null | undefined) => string;

interface Valores {
  hoje: number | null;
  mtd: number | null;
  m1: number | null;
  ref: number | null;
}

function Delta({ atual, base, direcao, formato }: { atual: number | null; base: number | null; direcao: Direcao; formato: Fmt }) {
  if (atual === null || base === null) return null;
  const d = atual - base;
  if (Math.abs(d) < 1e-9) return <div className="wd delta-neutral">=</div>;
  const favoravel = direcao === 'up' ? d > 0 : d < 0;
  return (
    <div className={`wd ${favoravel ? 'delta-good' : 'delta-bad'}`}>
      {d > 0 ? '▲' : '▼'} {formato(Math.abs(d))}
    </div>
  );
}

interface Props {
  label: string;
  valores: Valores;
  refLabel: string;
  m1Label?: string;
  formato: Fmt;
  formatoDelta?: Fmt;
  direcao?: Direcao;
  extra?: string;
  ajuda?: string;
}

export default function KpiCard({ label, valores, refLabel, m1Label, formato, formatoDelta, direcao = 'up', extra, ajuda }: Props) {
  const fd = formatoDelta || formato;
  return (
    <div className="kpi">
      <div className="label flex items-start justify-between gap-2">
        <span>{label}</span>
        {ajuda && <Dica titulo={label} texto={ajuda} />}
      </div>
      <div className="value">{formato(valores.mtd)}</div>
      <div className="janela-tag">MÊS CORRENTE (MTD)</div>
      {extra && <div className="text-[12.5px] text-ink-2 mt-1">{extra}</div>}
      <div className="windows">
        <div className="w">
          <div className="wl">Hoje</div>
          <div className="wv">{formato(valores.hoje)}</div>
        </div>
        <div className="w">
          <div className="wl" title="Comparação justa: mês anterior até o mesmo dia">{m1Label || 'M-1'}</div>
          <div className="wv">{formato(valores.m1)}</div>
          <Delta atual={valores.mtd} base={valores.m1} direcao={direcao} formato={fd} />
        </div>
        <div className="w">
          <div className="wl">{refLabel}</div>
          <div className="wv">{formato(valores.ref)}</div>
          <Delta atual={valores.mtd} base={valores.ref} direcao={direcao} formato={fd} />
        </div>
      </div>
    </div>
  );
}
